import { useEffect } from 'react';

type AnalyticsPageViewProps = {
  endpoint?: string;
  companyId?: string;
  assetId?: string;
  recordSessionReplay?: boolean;
  preview?: boolean;
};

export function AnalyticsPageView({
  endpoint,
  companyId,
  assetId,
  recordSessionReplay,
  preview,
}: AnalyticsPageViewProps) {
  useEffect(() => {
    if (preview || !endpoint || !companyId || !assetId) {
      return;
    }

    void import('@mutiny-pkg/analytics-tracker/src/index')
      .then(({ init }) => {
        init({
          endpoint,
          companyId,
          assetId,
          recordSessionReplay,
        });
      })
      .catch(() => {
        // Tracking must never break published page rendering.
      });
  }, [assetId, companyId, endpoint, preview, recordSessionReplay]);

  return null;
}
